import { AppUserInitialStateResponse } from '@src/models/api'
import { EmployeePermission } from '@src/models/EmployeePermission'

export const getMissingPermissions = (
    user: AppUserInitialStateResponse,
    requiredPermissions: EmployeePermission[]
): EmployeePermission[] => {
    return requiredPermissions.filter((permission) => !user.permissions?.includes(permission))
}

export const checkUserPermissions = (
    user: AppUserInitialStateResponse,
    requiredPermissions: EmployeePermission[]
): boolean => {
    return getMissingPermissions(user, requiredPermissions).length === 0
}
